import React, { useState, useEffect } from 'react';
import HttpHelper from '../service/httpService';
import swal from 'sweetalert';
import { useHistory } from 'react-router-dom';
import { SystemDashboardLayout, SystemTile } from '../library';
import HeaderDashboard from '../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import Opportunities from '../Components/Opportunities/Opportunities'
import { SystemGridAndForm } from 'library/form/SystemGridForm';
import OpportunitiesForm from '../Components/Opportunities/AddOpportunities';


const Dashboard = (props: any) => {


    useEffect(() => {

    }, [])

    return (<>
        <div className="DashboardWrapperChild">
            <div className="contentWrapper">
                <HeaderDashboard title="Top" tagLine="" />
                <div className="container-fluid mt-80">
                    <div className="row">
                        <SystemTile title="Opportunity List" description="List of Opportunities" icon="icon-files" link="/Opportunity" securityObject="Top.Opportunity" />
                        <SystemTile title="Dashboard" description="Opportunity Charts" icon="icon-files" link="/opportunitychart" securityObject="Top.Dashboard" />
                        <SystemTile title="Chart Configuration" description="Chart Color Picker" icon="icon-files" link="/Chart-color" securityObject="Top.ChartColors" />
                        <SystemTile title="Lookup Tables" description="Lookup" icon="icon-files" link="/Lookup" securityObject="Top.Lookup" />
                        {/*<SystemTile title="Lookup Request" description="Lookup Request" icon="icon-files" link="/Lookup-Request" securityObject="Top.LookupRequest" />*/}
                        <SystemTile title="Office Locations" description="Office Locations" icon="icon-files" link="/Office-Location" securityObject="Top.Locations" />
                        <SystemTile title="Project Score Card Versions" description="Project Score Card Versions" icon="icon-files" link="/Project-Score-Card" securityObject="Top.ScoreCardVersions" />
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default Dashboard;